import { Link, Navigate, useNavigate } from "react-router-dom";
import Table from "../../extra/Table";
import Button from "../../extra/Button";
import Title from "../../extra/Title";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getLiveSeller, endLiveStream } from "../../store/seller/seller.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import "react-loading-skeleton/dist/skeleton.css";
import Info from "../../../assets/images/Info.svg"
import defaultImage from "../../../assets/images/default.jpg";

import InfoOutlined from '@mui/icons-material/InfoOutlined';
import StopCircleOutlined from '@mui/icons-material/StopCircleOutlined';
import Iconb from "../../extra/Iconb";

const LiveSeller = (props) => {
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState("");

  // Phase-2 #33: preset end-live reasons — persisted server-side and sent
  // to the host as a notification.
  const END_REASONS = [
    "Policy violation",
    "Inappropriate content",
    "Copyright / IP complaint",
    "Spam or scam",
    "Requested by host",
    "Other",
  ];
  const [endTarget, setEndTarget] = useState(null);
  const [endReason, setEndReason] = useState("Policy violation");
  const [customReason, setCustomReason] = useState("");

  const { liveSeller } = useSelector((state) => state.seller);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLiveSeller(currentPage, size));
  }, [dispatch, currentPage, size]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(liveSeller);
  }, [liveSeller]);

  // // pagination
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event), 10);
    setSize(parseInt(event), 10);
    setCurrentPage(1);
  };

  const handleOpen = (id) => {
    navigate("/admin/liveSellerProduct", {
      state: id,
    })
  };

  // Handle end live stream — opens the reason-picker modal (#33).
  const handleEndLive = (row) => {
    setEndReason("Policy violation");
    setCustomReason("");
    setEndTarget(row);
  };

  const confirmEndLive = () => {
    if (!endTarget) return;
    const hostType = endTarget.isAffiliate ? "affiliate" : "seller";
    const reason =
      endReason === "Other" ? customReason.trim() || "Policy violation" : endReason;
    dispatch(endLiveStream(endTarget.liveSellingHistoryId, hostType, reason));
    setEndTarget(null);
  };

  // searching

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white">{index + 1}</span>,
    },
    {
      Header: "Seller",
      body: "firstName",
      Cell: ({ row }) => (
        <div className="d-flex">
          <div className="position-relative">
            {loading ? (
              <>
                <Skeleton
                  height={80}
                  width={80}
                  className="StripeElement "
                  baseColor={colors?.baseColor}
                  highlightColor={colors?.highlightColor}
                />
              </>
            ) : (
              <>
                <img
                  src={row?.image}
                  style={{ borderRadius: "10px" }}
                  height={80}
                  width={80}
                  alt=""
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
                <div
                  className="ping"
                  style={{
                    position: "absolute",
                    bottom: "0px",
                    left: "0px",
                  }}
                >
                  .
                </div>
              </>
            )}
          </div>
          <span className="boxCenter text-start ms-3">
            <b className="fw-normal text-white">{row?.firstName + " " + row?.lastName}</b>
          </span>
        </div>
      ),
      sorting: false,
    },

    {
      Header: "Email",
      body: "email",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 fw-normal text-white">
            {row.email ? row.email : "-"}
          </p>
        </div>
      ),
      sorting: false,
    },
    {
      Header: "Contect",
      body: "contect",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row.mobileNumber ? row.mobileNumber : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Business Name", body: "businessName",

      Cell: ({ row }) => (
        <>
          <span className="text-white fw-normal">
            {row.businessName ? row.businessName : "-"}
          </span>
        </>
      ),
    },
    {
      Header: "Business Tag", body: "businessTag",

      Cell: ({ row }) => (
        <>
          <span className="text-white fw-normal">
            {row.businessTag ? row.businessTag : "-"}
          </span>
        </>
      ),
    },
    {
      Header: "View", body: "view",

      Cell: ({ row }) => (
        <>
          <span className="text-white fw-normal">
            {row.view ? row.view : "-"}
          </span>
        </>
      ),
    },

    {
      Header: "View Product",
      body: "",
      Cell: ({ row }) => (

        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<InfoOutlined sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",

            padding: "0px"
          }}
          isImage={true}
          isDeleted={true}
          // disabled={row.isFake === true ? true : false}  //if user fake then not open
          onClick={() => handleOpen(row)}


        />
        // <Button
        //   newClass={`${
        //     row.isFake === true ? "grayText" : "themeFont"
        //   } boxCenter userBtn fs-4`}
        //   btnColor={``}

        //   btnIcon={`bi bi-info-circle`}
        //   onClick={() => handleOpen(row?._id)}
        //   disabled={row.isFake === true ? true : false}
        //   style={{
        //     borderRadius: "5px",
        //     margin: "auto",
        //     width: "40px",
        //     backgroundColor: "#fff",
        //   }}
        // />
      ),
    },
    {
      Header: "End Live",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<StopCircleOutlined sx={{ color: '#dc3545' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#dc3545",
            padding: "0px",
            cursor: row.isFake ? "not-allowed" : "pointer",
            opacity: row.isFake ? 0.5 : 1,
          }}
          isImage={true}
          isDeleted={true}
          disabled={row.isFake === true}
          onClick={() => !row.isFake && handleEndLive(row)}
          title={row.isFake ? "Cannot end fake seller streams" : "End this live stream"}
        />
      ),
    },

    // add more columns as needed
  ];
  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Live Seller </div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="sellerHeader primeHeader">
                <div className="row">

                  <div className="col-12 text-end">
                    <Searching
                      type={`client`}
                      data={liveSeller}
                      setData={setData}
                      column={data}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                      button={true}
                      setSearchValue={setSearch}
                      searchValue={search}
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                serverPerPage={rowsPerPage}
                serverPage={page}
                type={"server"}
              />
              {/* <Pagination
                component="div"
                count={liveSeller?.length}
                type={"server"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={liveSeller?.length}
                serverPage={currentPage}
                setCurrentPage={setCurrentPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>

      {endTarget && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setEndTarget(null)}
        >
          <div
            style={{ background: "#1A1614", border: "1px solid #F0C420", borderRadius: 12, padding: 24, width: 420, maxWidth: "92vw" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5 style={{ color: "#FFFDF7", marginBottom: 4 }}>End live stream</h5>
            <p style={{ color: "#8A857F", fontSize: 13 }}>
              {endTarget.businessName || `${endTarget.firstName || ""} ${endTarget.lastName || ""}`.trim() || "This host"} — all
              viewers will be disconnected and the host is notified with the reason below.
            </p>
            {END_REASONS.map((r) => (
              <label key={r} style={{ display: "flex", alignItems: "center", gap: 8, color: "#FFFDF7", padding: "6px 2px", cursor: "pointer" }}>
                <input type="radio" name="endReason" checked={endReason === r} onChange={() => setEndReason(r)} />
                {r}
              </label>
            ))}
            {endReason === "Other" && (
              <input
                type="text"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Enter reason…"
                maxLength={200}
                style={{ width: "100%", marginTop: 8, padding: "8px 10px", borderRadius: 8, border: "1px solid #8A857F", background: "#FFFDF7", color: "#1A1614" }}
              />
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 18 }}>
              <button className="btn btn-sm" style={{ border: "1px solid #8A857F", color: "#FFFDF7" }} onClick={() => setEndTarget(null)}>
                Cancel
              </button>
              <button className="btn btn-sm" style={{ background: "#dc3545", color: "#fff" }} onClick={confirmEndLive}>
                End stream
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect(null, { getLiveSeller, endLiveStream })(LiveSeller);
// export default LiveSeller;
